<template>
    <div class="c-o-company-section c-o-company-section--quality" id="quality">
        <div class="c-o-company-section__inner c-o-company-section__inner--offset-left" :class="{'c-o-company-section__inner--offset-right' : !showSidebar}">
            <div class="c-o-company-section__main">
                <h2 class="c-o-company-section__title h2">Kvalitetssäkring</h2>
                <div v-if="evaluationDate" class="c-o-company-section__diploma">
                    <span class="c-o-company-section__diploma-badge">
                        <icon :icon="'check_circle'"></icon>
                    </span>
                    <p class="c-o-company-section__diploma-heading">Kontrollerat av BraByggare:</p>
                    <p class="c-o-company-section__diploma-date h3">{{evaluationDate | formatDateWithoutTime }}</p>

                </div>
                <h3 class="c-o-company-section__details-header">Företagsuppgifter</h3>
                <ul class="c-o-company-section__details">
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Organisationsnummer:</span>
                        {{orgNr}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Innehar F-skattesedel:</span>
                        {{hasTaxReg}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Bransch:</span>
                        {{bransch}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Reg. datum firma:</span>
                        {{regDate | formatDateWithoutTime }}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Registrerad för moms:</span>
                        {{hasVatReg}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Bolagsform:</span>
                        {{typeOfCompany}}
                    </li>
                </ul>
                <h3 class="c-o-company-section__details-header">Ansvarsförsäkring och kreditvärdighet</h3>
                <ul class="c-o-company-section__details">
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Ansvarsförsäkring:</span>
                        {{hasInsurance}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Kreditkontroll:</span>
                        {{creditControl}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Försäkringsbolag:</span>
                        {{insuranceCompany}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Bevakas via:</span>
                        {{guarded}}
                    </li>
                </ul>
                <h3 class="c-o-company-section__details-header">Svartlistning</h3>
                <ul class="c-o-company-section__details">
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">Brabyggare:</span>
                        {{blacklisted}}
                    </li>
                    <li class="c-o-company-section__detail">
                        <span class="c-o-company-section__detail-title">
                            Råd & Rön (<a target="_blank" :href="'https://www.radron.se/Svarta-listan/'">gå till lista</a>):
                        </span>
                        {{blacklisted}}
                    </li>
                </ul>
            </div>
            <div v-if="showSidebar" class="c-o-company-section__sidebar">
                <div class="c-o-company-section__sidebar-block">
                    <h3 class="c-o-company-section__sidebar-title">Certifieringar & branschorganisationer</h3>
                    <div class="c-o-company-section__sidebar-content">
                        <ul class="c-o-company-section__sidebar-certs">
                            <li v-for="item in certificates" v-if="item.Proven" :key="`company-cert-id-${item.CompanyCertID}`" class="c-o-company-section__sidebar-cert">
                                <div class="c-o-company-section__sidebar-cert-logo">
                                    <img :src="imagePrefix + item.Image" :alt="`Bild på ${item.Description} logotyp`">
                                </div>
                                <div class="c-o-company-section__sidebar-cert-info">
                                    <p class="c-o-company-section__sidebar-cert-text" v-html="item.Description"></p>
                                    <a class="c-o-company-section__sidebar-cert-link" target="_blank" :href="item.Link">{{item.LinkText}}</a>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Icon from '../../atoms/AtomIcon.vue'
    import ButtonLink from '../../atoms/AtomButtonLinkExternal.vue'
    import Filters from '../../../../filters/index.js'

    export default {
        props: [
            'orgNr',
            'quality',
            'certificates'
        ],
        components: {
            Icon,
            ButtonLink
        },
        filters: Filters,
        data() {
            return {
            }
        },
        computed: {
            evaluationDate: function() {
                return this.quality.EvaluationDate
            },
            hasTaxReg: function() {
                return this.quality.HasTaxRegistration ? 'Ja' : 'Nej'
            },
            bransch: function() {
                return this.quality.Branch
            },
            regDate: function() {
                return this.quality.RegistrationDate
            },
            hasVatReg: function() {
                return this.quality.HasVATRegistration ? 'Ja' : 'Nej'
            },
            typeOfCompany: function() {
                return this.quality.CompanyForm
            },
            hasInsurance: function() {
                return this.quality.HasInsurance ? 'Ja' : 'Uppgift saknas'
            },
            creditControl: function() {
                return 'Kredit bevakas löpande, stängs av vid betalningsproblem'
            },
            insuranceCompany: function() {
                return this.quality.InsuranceCompany
            },
            guarded: function() {
                return 'Creditsafe'
            },
            blacklisted: function() {
                return 'Ej svartlistad'
            },
            showSidebar: function() {
                let proven = false;
                this.certificates.forEach(item => { if(item.Proven){ proven = true; } });
                return this.certificates.length > 0 && proven;
            },
            imagePrefix: function(){
                return 'https://static.brabyggare.se/certificates/';
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/company-sections/OrganismCompanySectionQuality.vue